import React from "react";
import { NextToJumpSkeleton } from "@/features/racing/components/Tabs/NextToJumpSkeleton";
import { Skeleton } from "@/components/Skeleton";

import * as styles from "./RaceMeeting.module.scss";

const RaceMeetingSkeleton = () => {
  return (
    <NextToJumpSkeleton
      count={7}
      icon={
        <Skeleton mode="light" shape="circle" className={styles.skeletonIcon} />
      }
      secondaryIcon={<> </>}
      longTitle
    />
  );
};

export { RaceMeetingSkeleton };
